import { render, staticRenderFns } from "./payment-data.component.vue?vue&type=template&id=a5d9f3a8"
import script from "./payment-data.component.vue?vue&type=script&lang=js"
export * from "./payment-data.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports